<script setup lang="ts">
import type { AiCompanionReviewModeEnum } from "@simbelapp/order-sdk";
import AppButton from "~/components/Common/Buttons/AppButton.vue";
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { trainingPrefillNoticeOf } from "~/utils/helpers/copilot/training-review";

const props = defineProps<{
  /** Create: values extracted into an empty form; update: proposals written over the stored training. */
  mode?: AiCompanionReviewModeEnum | null;
  /** No source document (its bucket may be unset): nothing to open in the viewer. */
  hasDocument?: boolean;
  /** The viewer already shows the document — no need to offer opening it. */
  viewerOpen?: boolean;
}>();

const emit = defineEmits<{ "open-viewer": [] }>();

const notice = computed(() => trainingPrefillNoticeOf(props.mode, !!props.viewerOpen));
</script>

<template>
  <div
    class="flex items-center justify-between gap-4 rounded-lg border border-ai-banner-stroke-color bg-ai-banner-color px-4 py-3"
  >
    <div class="flex items-center gap-2">
      <SvgIcon name="ai" class="h-[16px] w-[16px] shrink-0 text-ai-accent-color" />
      <span class="body_regular text-primary-color">{{ notice }}</span>
    </div>

    <AppButton
      v-if="hasDocument && !viewerOpen"
      type="link"
      icon="document"
      label="Voir le programme"
      class="shrink-0 whitespace-nowrap"
      @click="emit('open-viewer')"
    />
  </div>
</template>
